
import axios from "../services/axios-config.js";


// FUNÇÃO DE BUSCA DOS DADOS DAS COMPANHIAS
export const getCmvUsers = async () => {
    return new Promise(async (resolve, reject) => {
        try {
    
            const res = await axios.get(`/admin/cmv/users`);
    
            if (res.status == 200) {
                return resolve(res.data);
            }
    
        } catch (error) {
            console.error("ERROR - GET COMPANIES FUNCTION:", error);
            reject(error);
    
        }

    })

};